module.exports = __webpack_public_path__ + "img/log-out.5c259d0f.svg";